import React from 'react';
import { Route, RouteProps, RouteComponentProps } from 'react-router-dom';
import { ProtectedRoute } from './ProtectedRoute';

interface AdminRouteProps extends Omit<RouteProps, 'component'> {
  component: React.ComponentType<RouteComponentProps<any>> | React.ComponentType<any>;
}

/**
 * Route component that ensures only Admin users can access the wrapped component
 * Leverages the ProtectedRoute component for authentication checking
 */
export const AdminRoute: React.FC<AdminRouteProps> = ({
  component: Component,
  ...rest
}) => {
  return (
    <Route
      {...rest}
      render={(props) => (
        <ProtectedRoute roles={['Admin', 'admin']}>
          <Component {...props} />
        </ProtectedRoute>
      )}
    />
  );
};